import apiRequest from '@utils/request/request';

export * from './request';
export default apiRequest;
